import { useParams } from "wouter"
import { Link } from "wouter"

export function TagProjectsPage() {
  const { tag } = useParams<{ tag: string }>()

  const decodedTag = decodeURIComponent(tag ?? "")

  return (
    <div className="pointer-events-none flex h-full flex-col items-end justify-end gap-4 p-6">
      <div className="pointer-events-auto flex items-center gap-3 rounded-lg bg-black/60 px-4 py-2 backdrop-blur-sm">
        <span className="text-sm text-foreground/60">Filtering by:</span>
        <span className="rounded bg-white/20 px-2 py-0.5 text-sm font-medium">{decodedTag}</span>
        <Link to="/projects" className="ml-2 text-sm text-foreground/60 transition-colors hover:text-foreground">
          Clear
        </Link>
      </div>
      <p className="text-sm text-foreground/40">Click a project to explore</p>
    </div>
  )
}
